import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { authProtectedRoutes, publicRoutes } from './allRoutes';
import Layout from 'Layout';
import NonAuthLayout from "Layout/NonLayout"
import AuthProtected from './AuthProtected';
import RoleProtected from './RoleProtected';

const RouteElement: React.FC<{ Component: React.ComponentType<any> }> = ({ Component }) => {
  return <Component />;
};

const RouteIndex = () => {
  return (
    <React.Fragment>
      <Routes>
        {authProtectedRoutes.map((route: any, idx: number) => {
          const Component = route.component;
          return (
            <Route
              key={idx}
              path={route.path}
              element={
                <AuthProtected>
                  <RoleProtected>
                    <Layout>
                      <RouteElement Component={Component} />
                    </Layout>
                  </RoleProtected>
                </AuthProtected>
              }
            />
          );
        })}
        {publicRoutes.map((route: any, idx: number) => (
          <Route
            path={route.path}
            key={idx}
            element={
              <NonAuthLayout>
                {(() => { const Component = route.component; return <RouteElement Component={Component} />; })()}
              </NonAuthLayout>
            } />
        ))}
      </Routes>
    </React.Fragment>
  );
};

export default RouteIndex;
